import type { CartQuery } from '@schema/main';
import type { Flatten } from '@root/src/types';
import { getFlocktoryQueue } from './types';
import type { CartT } from '@store/CartStore.type';

type CartItem = Flatten<NonNullable<CartQuery['cart']['items']>>;

interface FlocktoryCartItemPayload {
  id: string;
  price: number;
  count: number;
}

const mapCartItems = (
  items: CartItem[] | null | undefined
): FlocktoryCartItemPayload[] => {
  if (!items?.length) {
    return [];
  }

  return items
    .filter(item => item?.product?.id && item.amount)
    .map(item => ({
      id: String(item.product?.id),
      price: item.product?.price ?? 0,
      count: item.amount ?? 0
    }));
};

export const syncFlocktoryCart = (cart: CartT): void => {
  const items = mapCartItems(cart?.items);

  getFlocktoryQueue().push?.([
    'updateCart',
    {
      cart: { items }
    }
  ]);
};
